import React, { Component, Fragment, useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const Shipping = (props) =>{
    const [CheckoutForm, setCheckoutForm] = useState()

    
    return (
        <>
        <h1>Payment</h1>
        </>
    )
    
}
export default Shipping